import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCap24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCap24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.291 9.098 12 5.444l7.709 3.654-7.71 3.656zm7.28-5.11a1 1 0 0 1 .857 0l8.876 4.207a1 1 0 0 1 0 1.807L19 11.095v5.015l-.239.223-.511-.548.51.548-.001.002-.003.003-.009.008a2 2 0 0 1-.119.102c-.078.065-.19.154-.336.258-.29.209-.715.481-1.265.752-1.103.541-2.716 1.077-4.777 1.077-1.621 0-2.964-.331-4-.736v2.208l-2.5.027-2.5-.027v-3.89c0-1.044.735-1.928 1.75-2.226v-2.796l-2.304-1.093a1 1 0 0 1 0-1.807zM8.25 16.167c.93.439 2.277.867 4 .867 1.795 0 3.182-.465 4.115-.924a7.4 7.4 0 0 0 1.135-.684v-3.62l-5.071 2.404a1 1 0 0 1-.857 0L6.5 11.806v2.085c1.014.298 1.75 1.182 1.75 2.227zm-1.5-.043v-.007c0-.365-.349-.833-1-.833-.652 0-1 .468-1 .833v2.405l1 .011 1-.01z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCap24);
